import { WORDMARK_PATHS, WORDMARK_VIEWBOX } from '../core/wordmark.ts'

/// The wordmark as markup (ADR 0028 decision 6): an image named Interplae, filled from the theme's
/// tokens, never a background or an inverted picture. Its height comes from the place that sets it.
export function Wordmark({ className }: { className?: string }) {
  return (
    <svg className={className ? `wordmark ${className}` : 'wordmark'} viewBox={WORDMARK_VIEWBOX} role="img" aria-label="Interplae" focusable="false" xmlns="http://www.w3.org/2000/svg">
      {WORDMARK_PATHS.map(p => <path key={p.fill} fill={`var(${p.fill})`} d={p.d} />)}
    </svg>
  )
}
